import {Component, inject} from '@angular/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCommentDots} from '@fortawesome/free-solid-svg-icons';
import {DialogService} from '../../../services/dialog/dialog.service';

/**
 * Floating action button, mounted once in the app shell so it appears on every route.
 * Hides itself while the panel is open (see DialogPanelComponent).
 */
@Component({
  selector: 'app-dialog-launcher',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './dialog-launcher.component.html',
})
export class DialogLauncherComponent {
  protected readonly dialogService = inject(DialogService);
  protected readonly faCommentDots = faCommentDots;

  open(): void {
    this.dialogService.open();
  }
}
